import * as z from "zod";

import { partnerIdSchema, partnerUserSchema } from "./shared";

/** Fails with a 409 when the email already belongs to a portal user. */
export const createPartnerUser = {
  name: "createPartnerUser" as const,
  input: z.object({
    partnerId: partnerIdSchema,
    email: z.email().max(320),
    name: z.string().trim().min(1).max(200).optional(),
  }),
  output: z.object({ user: partnerUserSchema }),
};
